<section class="static-page">
  <header class="static-header">
    <span class="static-icon" aria-hidden="true"><i class="fa-solid fa-calendar-days"></i></span>
    <h1>Events &amp; Webinars</h1>
    <p class="static-subtitle">Product demos and sessions for orderYaa users.</p>
  </header>

  <div class="container">
    <div class="static-content">
      <p>
        From time to time we run live sessions covering new features, best practices for setting
        up your ERP, and Q&amp;A with our product team.
      </p>

      <h2>What to expect</h2>
      <ul>
        <li>Live walkthroughs of new modules and features as they launch</li>
        <li>Setup and onboarding sessions for new customers</li>
        <li>Q&amp;A with the orderYaa product team</li>
      </ul>

      <h2>Stay in the loop</h2>
      <p>
        We don't have anything scheduled right now. Follow us on
        <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
        or reach out directly and we'll let you know when the next session is coming up.
      </p>

      <div class="static-cta">
        <a
          class="btn"
          href="https://mail.google.com/mail/?view=cm&amp;fs=1&amp;to=hr@techcolleagues.com&amp;su=Events"
          target="_blank"
          rel="noopener noreferrer"
        >Ask about upcoming events</a>
      </div>
    </div>
  </div>
</section>
